import React from "react";
import { useParams } from "react-router-dom";
import Config from "../../_config/config";
import DocumentTemplateService from "../../_services/DocumentTemplateService";
import TemplateBuilder from "../../components/TemplateBuilder/TemplateBuilder";
import { INVOICE_VARIABLE_GROUPS } from "./invoice-variables";

/**
 * Invoice / receipt document editor. Same shared <TemplateBuilder> as the email
 * editor, but with the Mustache merge-field palette and no Subject/Send-Test —
 * and it persists to the `Mustache` column that nodefork's invoice renderer
 * reads, so edits here change real invoice output.
 */
const DocumentTemplateEditorPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const templateId = id === "new" ? null : parseInt(id, 10);

  return (
    <TemplateBuilder
      templateId={templateId}
      backPath="/document-templates"
      namePlaceholder="Document template name"
      uploadUrl={`${Config.nodeSiteUrl}v1/document-templates/upload-image`}
      editUrl={(newId) => `/document-templates/${newId}/edit`}
      variables={INVOICE_VARIABLE_GROUPS}
      loadTemplate={async (tid) => {
        const res = await DocumentTemplateService.get(tid);
        const data = res.data?.data || {};
        return {
          name: data.Name || "Untitled",
          subject: "",
          html: data.Mustache || null,
          designJson: data.DesignJson || null,
        };
      }}
      saveTemplate={async ({ id: tid, name, html, designJson }) => {
        const body = { Name: name, Mustache: html, DesignJson: designJson };
        if (tid) {
          await DocumentTemplateService.update(tid, body);
          return { id: tid };
        }
        const res = await DocumentTemplateService.create(body);
        return { id: res.data?.data?.Id };
      }}
    />
  );
};

export default DocumentTemplateEditorPage;
